module.exports = __webpack_public_path__ + "static/media/android_logo.63e2e88e.svg";